import { css } from 'linaria';

export const systemsSection = css`
  width: 100%;
  margin-bottom: 80px;

  @media (--only-tablet) {
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    margin-bottom: 48px;
  }
`;

export const systemsTitle = css`
  margin-bottom: 40px;

  @media (--only-desktop) {
    margin-bottom: 32px;
  }

  @media (--only-tablet) {
    margin-bottom: 24px;
  }

  @media (--only-mobile) {
    margin-bottom: 16px;

    && {
      font-weight: 500;
      font-size: 26px;
      line-height: 32px;
    }
  }
`;

export const systems = css`
  display: grid;
  grid-template-columns: repeat(3, 372px);
  grid-template-rows: 526px 471px;
  column-gap: 32px;
  row-gap: 40px;

  @media (--only-desktop) {
    grid-template-columns: repeat(3, 297px);
    grid-template-rows: 504px 432px;
    column-gap: 24px;
    row-gap: 32px;
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 322px);
    grid-template-rows: 445px 445px 405px;
    column-gap: 16px;
  }

  @media (--only-mobile) {
    grid-template-columns: 100%;
    grid-template-rows: 388px 388px 348px 372px 408px;
    column-gap: 0;
    row-gap: 32px;
  }
`;

export const systemsImageWrapper = css`
  width: 100%;
  height: 230px;

  @media (--only-desktop) {
    height: 184px;
  }

  @media (--only-tablet) {
    height: 199px;
  }

  @media (--only-mobile) {
    height: 178px;
  }
`;

export const systemsImage = css`
  width: 372px;
  height: 230px;
  object-fit: cover;

  @media (--only-desktop) {
    width: 297px;
    height: 184px;
  }

  @media (--only-tablet) {
    width: 322px;
    height: 199px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 178px;
  }
`;

export const systemsCardContent = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
  padding: 16px 24px 24px;

  @media (--only-desktop) {
    padding: 16px;
    padding-right: 12px;
    padding-bottom: 24px;
  }

  @media (--only-tablet) {
    padding: 16px 16px 24px;
  }

  @media (--only-mobile) {
    padding: 8px 12px 24px;
  }
`;

export const cardTitle = css`
  @media (--only-tablet) {
    font-size: 20px;
    line-height: 26px;
  }

  @media (--only-mobile) {
    margin-bottom: 2px;
    font-size: 18px;
    line-height: 24px;
  }
`;

export const cardDescription = css`
  @media (--only-tablet) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const cardButton = css`
  && {
    @media (--only-tablet) {
      padding: 10px 22px;
      font-size: 16px;
      line-height: 24px;
    }

    @media (--only-mobile) {
      height: 40px;
      padding: 10px 20px;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const cardCommonStyle = css`
  :hover button {
    background-color: var(--control-hover-primary);
  }
`;
